import React, { Component } from "react";
import "./ResNavBar.scss";
import {
  HomeOutlined,
} from "@ant-design/icons";
import localization from '../../Localization/Localization.json'
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { FaArchive, FaFileContract } from "react-icons/fa";

class ResNavBar extends Component {
  render() {
      const {currentLang, cartItems} = this.props;
    return (
      <div className="res-bottom-nav">
        <NavLink
        exact 
        strict
          to="/orders"
        >
            <FaArchive />
          {localization.orders[currentLang]} 
        </NavLink>
        <NavLink
        exact 
        strict
          to="/"
        >
          <HomeOutlined />
          {localization.home[currentLang]} 
        </NavLink>
        <NavLink
        exact 
        strict 
          to="/bonds"
        >
          <FaFileContract />
          السندات
        </NavLink>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    currentLang : state.user.currentLang,
}) 
  
export default connect(mapStateToProps)(ResNavBar); 